import {
  enableProdMode,
  importProvidersFrom
} from "@angular/core";
import "@capgo/camera-preview";
import { environment } from "./environments/environment";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { provideRouter, RouteReuseStrategy } from "@angular/router";
import { routes } from "src/app/app-routing.module";
import { HttpClient, provideHttpClient } from "@angular/common/http";
import {
  provideTranslateService,
  TranslateLoader,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  provideIonicAngular,
  IonicRouteStrategy
} from "@ionic/angular/standalone";
import { addIcons } from "ionicons";
import {
  moon,
  sunny,
  atCircle,
  informationCircle,
  informationCircleOutline,
  lockClosed,
  micOutline,
  call,
  close,
  alertCircleOutline,
  checkmarkCircleOutline,
  helpCircleOutline,
  lockClosedOutline,
  closeOutline,
  warningOutline,
  closeCircle,
  chevronUp
} from "ionicons/icons";

if (environment.production) {
  enableProdMode();
}

addIcons({
  moon,
  sunny,
  atCircle,
  informationCircle,
  informationCircleOutline,
  lockClosed,
  micOutline,
  call,
  close,
  alertCircleOutline,
  checkmarkCircleOutline,
  helpCircleOutline,
  lockClosedOutline,
  closeOutline,
  warningOutline,
  closeCircle,
  chevronUp
});

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    // https://ionicframework.com/docs/angular/build-options
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({ innerHTMLTemplatesEnabled: true, mode: 'md', useSetInputAPI: true }),
    importProvidersFrom(BrowserAnimationsModule)
  ]
}).catch((err) => {});
